<template>
  <v-carousel
    v-model="index"
    height="40"
    :style="'min-width:210px'"
    hide-delimiters
    show-arrows-on-hover
    hide-delimiter-background
    progress
  >
    <v-carousel-item v-for="(item, i) in items" :key="i">
      <div v-if="item.nome != 'EXECUTANDO'" class="text-center text-h2" :style="`color:${colorStatus(item.nome)};font-size:10px`">
        <b>{{ item.nome === 'NAO EXECUTADO' ? 'NÃO EXECUTADO' : item.nome }}</b>
      </div>
      <div v-else>
        <v-progress-circular indeterminate color="grey" size="17" width="3" class="mt-n2" />
      </div>
      <div :class="item.nome == 'EXECUTANDO' ? 'mt-n1' : ''">{{ title }} {{ i + 1 }} - {{ item.tipo }}</div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      title: {
        type: String
      }
    },

    data() {
      return {
        index: null
      };
    },

    created() {
      this.defineIndexStatus();
    },

    methods: {
      colorStatus(status) {
        switch (status) {
          case 'SUCESSO':
            return 'green';
          case 'AGUARDANDO':
            return '#3fa6f4';
          case 'EXPIRADO':
            return 'gray';
          case 'FALHA':
            return 'red';
          case 'NAO EXECUTADO':
            return 'gray';
        }
      },

      defineIndexStatus() {
        let itemsStatus = this.items.map((item) => item.nome);

        let itemsNotWaiting = itemsStatus.filter((item) => item !== 'AGUARDANDO');

        if (itemsNotWaiting.length == 0) this.index = 0;

        if (itemsStatus.indexOf('EXECUTANDO') != -1) this.index = itemsStatus.indexOf('EXECUTANDO');

        if (itemsStatus.indexOf('FALHA') != -1 || itemsStatus.indexOf('SUCESSO') != -1) {
          let arrayStatus = [];

          let statusError = itemsStatus.indexOf('FALHA');
          let statusSuccess = itemsStatus.indexOf('SUCESSO');

          while (statusError != -1) {
            arrayStatus.push(statusError);
            statusError = itemsStatus.indexOf('FALHA', statusError + 1);
          }

          while (statusSuccess != -1) {
            arrayStatus.push(statusSuccess);
            statusSuccess = itemsStatus.indexOf('SUCESSO', statusSuccess + 1);
          }

          this.index = arrayStatus.reduce((a, b) => Math.max(a, b), 0);
        }
      }
    }
  };
</script>

<style>
  .v-window .v-window__container .v-window__prev,
  .v-window .v-window__container .v-window__next {
    background: transparent !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    border-radius: 0 !important;
  }

  .v-window .v-window__container .v-window__prev .v-icon,
  .v-window .v-window__container .v-window__next .v-icon {
    color: #a6a6a6;
  }
</style>
